import React from 'react'
import { grid, s } from '../style'

const Grid = ({
  container,
  xs,
  sm,
  md,
  lg,
  xl,
  item,
  ccss,
  children,
  className,
  // onClick,
  ...props
}) => {
  const XS = xs
  const SM = sm || XS
  const MD = md || SM
  const LG = lg || MD
  const XL = xl || LG

  return (
    <div
      {...props}
      className={className}
      css={[
        { display: 'flex' },
        container && { flexWrap: 'wrap' },
        item && {
          [s.xs]: { flexBasis: grid(XS), maxWidth: grid(XS) },
          [s.sm]: { flexBasis: grid(SM), maxWidth: grid(SM) },
          [s.md]: { flexBasis: grid(MD), maxWidth: grid(MD) },
          [s.lg]: { flexBasis: grid(LG), maxWidth: grid(LG) },
          [s.xl]: { flexBasis: grid(XL), maxWidth: grid(XL) },
        },
        ccss,
      ]}>
      {children}
    </div>
  )
}

export default Grid
